/**
 * Big Circle
 * Large circle background that shows behind drilldowns
 * Mobile height can be set to match size of headers on mobile
 */
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

import {
  BigCircleDiv,
  CircleWrapper, // MobileCircleDiv,
} from './BigCircle.style';

interface BigCircleProps {
  /** @deprecated */
  mobileHeight?: number;
  show?: boolean;
}

const BigCircle: React.FC<BigCircleProps> = () => {
  const mobile = useIsMobile();

  return (
    <CircleWrapper>
      {mobile ? null : <BigCircleDiv data-testid="big-circle" />}
    </CircleWrapper>
  );
};

export default BigCircle;
